import React, { useCallback, useRef } from 'react'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import './Slider.css'
import { TfiHeadphoneAlt } from 'react-icons/tfi'
import { FaChevronRight } from 'react-icons/fa6'
import slider1 from '../../../../assets/img/slider1.webp'
import slider2 from '../../../../assets/img/slider2.webp'
import slider3 from '../../../../assets/img/slider3.webp'
import slider4 from '../../../../assets/img/slider4.webp'
import { Link } from 'react-router-dom';
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'


function Hmslider() {

  const sliderWrapperRef = useRef(null)
  const timelineRef = useRef(null)

  const handleClick =()=>{
    window.scrollTo(0,0);
  }

  const animateSlideContent = useCallback(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (prefersReducedMotion) {
      return
    }

    const currentSlide = sliderWrapperRef.current?.querySelector('.slick-slide.slick-current')

    if (!currentSlide) {
      return
    }

    const title = currentSlide.querySelector('h2')
    const paragraph = currentSlide.querySelector('p')
    const buttons = currentSlide.querySelectorAll('.btnmn-tx')
    const image = currentSlide.querySelector('.hmslder-img img')

    if (!title || !paragraph || !buttons.length || !image) {
      return
    }

    timelineRef.current?.kill()

    const tl = gsap.timeline()
    tl.fromTo(title, { autoAlpha: 0, y: 60 }, { autoAlpha: 1, y: 0, duration: 0.7, ease: 'power3.out' })
      .fromTo(paragraph, { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power3.out' }, '-=0.35')
      .fromTo(buttons, { autoAlpha: 0, y: 40 }, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power3.out', stagger: 0.12 }, '-=0.2')
      .fromTo(image, { autoAlpha: 0, scale: 1.12 }, { autoAlpha: 1, scale: 1, duration: 1.4, ease: 'power3.out' }, '-=1')

    timelineRef.current = tl
  }, [])

  useGSAP(() => {
    animateSlideContent()

    return () => {
      timelineRef.current?.kill()
    }
  }, { dependencies: [animateSlideContent], scope: sliderWrapperRef })

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 7000
  };

  const sliderdata = [
    {
      slidtittle: "Your first step towards transformation",
      slidpara: "Our comprehensive Enterprise Application Development & Optimization Services are designed to revolutionize your business value chain, accelerating your journey into the digital realm.",
      slidimg:slider1,
      link: "/your-first-step-towards-transformation"
    },
    {
      slidtittle: "Perfecting a highly streamlined and agile development process",
      slidpara: "We at 360 Bytes follow a highly streamlined and agile development process to ensure fast paced execution and speedy delivery time without compromising on quality standards.",
      slidimg:slider2,
      link: "/Perfecting-highly-streamlined-and-agile-development-process"
    },
    {
      slidtittle: "Tailoring your needs with the sharpest tools",
      slidpara: "With Game-Changing Tools and cutting edge technology tailored to your exact needs, our team puts careful attention towards analyzing your development needs and works closely to define an application software that complements your business.",
      slidimg:slider3,
      link: "/tailoring-your-needs-with-the-sharpest-tools"
    },
    {
      slidtittle: "Leading you through a journey of digital excellence",
      slidpara: "With 360 Bytes, you can rest assured to find the perfect path to take you to excellence. Over the years we have established ourselves as the leading service provider for Mobile Application Development, Website Design & Development, Web and Graphic Design, E-Commerce Development, Software as a Solution (Saas - cloud solution), Digital Transformation and Product Engineering.",
      slidimg:slider4,
      link: "/leadin-you-through-a-journey-of-digital-excellence"
    }
  ]

  return (
    
    <div className='hm-slider-wrapper' ref={sliderWrapperRef}>
    <Slider {...settings} className='hm-slider'>
      {
        sliderdata.map((item, index)=>(
          <div className='hmslder-sec' key={index}>
            <div className='container'>
              <div className='hmslder-txt'>
                  <h2>
                    {
                      (() => {
                        const words = item.slidtittle.split(" ");
                        return (
                          <>
                            {words.slice(0, 1).join(" ") + " "}
                            <span >
                              {words.slice(1, 3).join(" ") + " "}
                            </span>
                            {words.slice(3).join(" ")}
                          </>
                        );
                      })()
                    }
                  </h2>
                  <p>{item.slidpara}</p>
                  <div className='btnmn-tx'>
                    <button className='btn-main'><Link to={item.link} onClick={handleClick}><span>Know More</span> <FaChevronRight/></Link></button>
                    <button className='btn-tx'  onClick={() => window.location.href = '/contact'}><TfiHeadphoneAlt/> <span>talk to expert</span></button>
                  </div>
                </div> 
              <div className='hmslder-img'><img src={item.slidimg} alt='' loading="lazy" /></div>  
            </div>
        </div>

        ))
      }
        

    </Slider>
    </div>

    
  )
}

export default Hmslider
